

import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AddButton extends Vue {
  @Prop({ default: () => Vue.prototype.$gettext('Add') }) tooltip!: string
  @Prop({ default: false }) disabled!: boolean
}
